<template>
  <div>
    <BreadCrumbs
      :children="[
        {
          text: `Reportes`,
        },
      ]"
    />

    <div class="card ml-15">
      <div class="card-body">
        <ul class="nav nav-tabs mb-3" id="pills-tab" role="tablist">
          <li class="nav-item" role="presentation">
            <a
              class="nav-link active"
              id="pills-home-tab"
              data-toggle="pill"
              href="#pills-home"
              role="tab"
              aria-controls="pills-home"
              aria-selected="true"
              >Sucursales</a
            >
          </li>
          <li class="nav-item" role="presentation">
            <a
              class="nav-link"
              id="pills-profile-tab"
              data-toggle="pill"
              href="#pills-profile"
              role="tab"
              aria-controls="pills-profile"
              aria-selected="false"
              >Bonos</a
            >
          </li>
        </ul>

        <div class="tab-content" id="pills-tabContent">
          <div
            class="tab-pane fade show active"
            id="pills-home"
            role="tabpanel"
            aria-labelledby="pills-home-tab"
          >
            <!-- ORDEN COMERCIOS -->
            <orders-report />
          </div>

          <!-- DISTANCIA RANGO -->
          <div
            class="tab-pane fade show"
            id="pills-profile"
            role="tabpanel"
            aria-labelledby="pills-profile-tab"
          >
            <report-comerce />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrdersReport from "./OrdersReport.vue";
import ReportComerce from "./ReportComerce.vue";
export default {
  name: "ReportAdmin",
  components: {
    OrdersReport,
    ReportComerce,
  },
};
</script>

<style scoped>
tbody td {
  font-weight: 500 !important;
}
.fa {
  font-size: 1.2rem;
}
</style>
